import { Component, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { StoreService } from "../../services/store.service";
import { GlobalService } from "../../services/global.service";
import { LoanDashboardService } from "src/app/loan-layout/components/loan-dashboard/loan-dashboard.service";
import { LogoutService } from "../../services/logout.service";
import { map } from "rxjs";

export interface SidebarItem {
    key: string;
    label: string;
    icon: string;
    activeIcon: string;
    route: string;
    selected?: string[];
}
export interface SidebarItemMap {
    HOME: SidebarItem;
    HISTORY: SidebarItem;
    HELP: SidebarItem;
    MORE: SidebarItem;
    REWARD_WALLET: SidebarItem;
}

@Component({
    selector: "web-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent {
    isMobile = true;
    @HostListener("window:resize")
    selectedTab: string = "";
    customerProfile: string = "assets/svg/icons/user-placeholder.svg";
    customerDetails!: any;

    menuItems: SidebarItemMap = {
        HOME: {
            key: "home",
            label: "Home",
            icon: "assets/svg/icons/sidebar-home.svg",
            activeIcon: "assets/svg/icons/sidebar-home-active.svg",
            route: "/loan/timeline",
            selected: ["/loan"],
        },
        HISTORY: {
            key: "history",
            label: "Loan History",
            icon: "assets/svg/icons/sidebar-loan-history.svg",
            activeIcon: "assets/svg/icons/sidebar-loan-history-active.svg",
            route: "/history",
            selected: ["/history"],
        },
        HELP: {
            key: "help",
            label: "Help & Support",
            icon: "assets/svg/icons/sidebar-help.svg",
            activeIcon: "assets/svg/icons/sidebar-help-active.svg",
            route: "/support",
            selected: ["/support"],
        },
        MORE: {
            key: "more",
            label: "More",
            icon: "assets/svg/icons/sidebar-more.svg",
            activeIcon: "assets/svg/icons/sidebar-more-active.svg",
            route: "/more-details",
            selected: ["/more-details", "/profile"],
        },
        REWARD_WALLET: {
            key: "reward-wallet",
            label: "Klinq Membership",
            icon: "assets/svg/icons/brand-icon.svg",
            activeIcon: "assets/svg/icons/brand-icon.svg",
            route: "/reward-wallet",
        },
    };

    constructor(
        private router: Router,
        private storeService: StoreService,
        private globalService: GlobalService,
        public loanDashboardService: LoanDashboardService,
        private logoutService: LogoutService
    ) {
        this.onResize();
        this.selectTab();
        this.router.events.subscribe(() => {
            this.selectTab();
        });

        this.globalService.customerDetails
            .pipe(
                map((details) => {
                    if (!details || typeof details !== "object" || Object.keys(details).length === 0) {
                        details = this.storeService.get("customerDetails");
                        details = typeof details === "string" ? JSON.parse(details) : details;
                    }

                    this.customerDetails = details;
                    this.customerProfile =
                        this.customerDetails &&
                        this.customerDetails?.customerProfile &&
                        this.customerDetails?.customerProfile != ""
                            ? details?.customerProfile
                            : "assets/svg/icons/user-placeholder.svg";
                })
            )
            .subscribe();
    }

    @HostListener("window:resize")
    onResize() {
        this.isMobile = window.innerWidth <= 820;
    }

    isRouteActive(currentUrl: string, route: string | string[]): boolean {
        return Array.isArray(route) ? route.some((r) => currentUrl.startsWith(r)) : currentUrl.startsWith(route);
    }
    profileOpen() {
        this.router.navigate(["/more-details"]);
        this.globalService.sidebarToggle.next(false);
    }

    selectTab() {
        const items = Object.values(this.menuItems);
        const activeItem = items.find((item) => this.isRouteActive(this.router.url, item.selected || item.route));
        this.selectedTab = activeItem ? activeItem.key : "home";
    }

    navigateTo(route: string, key: string) {
        this.selectedTab = key;
        this.globalService.sidebarToggle.next(false);

        if (route === "/loan/timeline") {
            this.loanDashboardService.getDashboardDetails(true);
        } else {
            this.router.navigate([route]);
        }
    }

    logout() {
        this.logoutService.logout();
    }

    goToDashboard() {
        this.globalService.sidebarToggle.next(false);
        const isLoading$ = this.loanDashboardService.loanDashboardSimmer.value;
        if (!isLoading$) {
            this.loanDashboardService.getDashboardDetails(true);
        }
    }
}
